// extracted by mini-css-extract-plugin
module.exports = {"emptyMessageContaner":"folksEmptyMessage_emptyMessageContaner__1ps4C"};